import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { MenuPayload, MenuResponse } from "@/types/interface/menu";

async function createMenu(payload: MenuPayload) {
  return await http.post<APIResponse<MenuResponse>>("menu/create", payload);
}

async function updateMenu(idMenu = '', payload: MenuPayload) {
  return await http.patch<APIResponse<MenuResponse>>(`menu/update?id=${idMenu}`, payload);
}

async function getMenu(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<MenuResponse>>(`menu?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findMenu(idMenu = "") {
  return await http.get<APIResponse<MenuResponse>>(`menu/detail?id=${idMenu}`);
}

async function deleteMenu(idMenu = "") {
  return await http.delete<APIResponse<MenuResponse>>(`menu/delete?id=${idMenu}`);
}

export default {
  createMenu,
  updateMenu,
  getMenu,
  findMenu,
  deleteMenu
};